import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { Google_map } from 'src/app/shared/google_map';
import { Gps } from 'src/app/shared/gps';
import { Geoutil } from 'src/app/shared/geoutil';
@Component({
  selector: 'app-drawonmap',
  templateUrl: './drawonmap.component.html',
  styleUrls: ['./drawonmap.component.css']
})
export class DrawonmapComponent extends BaseComponent implements OnInit {
  @ViewChild('pagemap',{static: true}) mapElement: any = {};
  google_map: Google_map;
  gps: Gps;
  radius = 100;
  showFilter = false;
  selectRadius = true;
  centerlatlng = {};

  constructor(injector: Injector) {super(injector) }

  ngOnInit(): void {
  }
  
  async initMap(){
    this.gps = new Gps();
    let { ok, data }: any = await this.gps.getLocation();
    if (!ok) return this.error("Cannot get GPS location: ", data);

    //translate from gps to googlemap space
    const latlng = data;

    this.google_map = new Google_map();
    this.google_map.init(this.mapElement.nativeElement,latlng,15);
    this.google_map.setMarker(latlng,"My current location");
    this.showFilter = true;

    this.google_map.clickOnMap((res:any)  => {
      let latlng = res.latLng.toJSON();
      if (this.selectRadius == true){
        this.google_map.addCircle(latlng,this.radius * 1.0);
        this.centerlatlng = latlng;
        this.selectRadius = false;
      }else{
        let d = Geoutil.getDistance(this.centerlatlng,latlng);
        alert("You are "+d.toFixed(1)+" meters from the center of the selectged circle")
      }
    })
  }
}
